<template>
  <v-card-text>
    <DateIntervalPicker
      v-model="interval"
      class="mb-3">
    </DateIntervalPicker>
    <v-layout row wrap>
      <v-flex xs12 sm4>
        <stat :title="$t('user.statistics.rates')" class="mb-4">
          {{ user.stats.rates_count }}
        </stat>
      </v-flex>
      <v-flex xs12 sm4>
        <stat :title="$t('user.statistics.ratesPending')" class="mb-4">
          {{ user.stats.purchases.to_rate }}
        </stat>
      </v-flex>
      <v-flex xs12 sm4>
        <stat :title="$t('user.statistics.ratesAverage')" class="mb-4">
          <stars v-if="user.stats.rate_average" :note="user.stats.rate_average"></stars>
          <span v-else>-</span>
        </stat>
      </v-flex>
      <v-flex xs12 sm4>
        <stat :title="$t('user.statistics.purchasesTotal')" class="mb-4">
          {{ user.stats.purchases.count }}
        </stat>
      </v-flex>
      <v-flex xs12 sm4>
        <stat :title="$t('user.statistics.purchasesAmount')" class="mb-4">
          <price :value="user.stats.purchases.total"></price>
        </stat>
      </v-flex>
      <v-flex xs12 sm4>
        <stat :title="$t('user.statistics.purchasesAverage')" class="mb-4">
          <price :value="user.stats.purchases.total / user.stats.purchases.count"></price>
        </stat>
      </v-flex>
      <v-flex xs12>
        <dashboard-purchases class="mb-4" :params="purchaseParams"></dashboard-purchases>
      </v-flex>
    </v-layout>
  </v-card-text>
</template>

<script>
  import withInterval from '@/mixins/withInterval'
  import Stars from '@/components/Stars.vue'
  import Stat from '@/components/Stat.vue'
  import { Price } from '@/components/formatters'
  import { DashboardPurchases } from '@/components/dashboard'
  import user from '@/mixins/user'
  export default {
    components: {
      Stars,
      Stat,
      Price,
      DashboardPurchases
    },
    mixins: [
      user,
      withInterval
    ],
    computed: {
      purchaseParams () {
        return {
          ...this.params,
          user_id: this.user.id
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/user/Statistics.vue